var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("letter-layout", {
    attrs: {
      title: "感恩命运，让我遇见了你",
      date: "2026年3月15日",
      "sign-date": "2026年3月10日",
      paragraphs: _vm.paragraphs,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }